import { formatHtml } from "@trumpf/ux.common-storybook";
import {
    SmartFactoryTemplate,
    SmartFactoryIconTemplate,
    SmartFactoryNumbersTemplate,
} from "./smart-factory.templates";

export default {
    title: "Website/Partial Templates/Smart factory",
    render: SmartFactoryTemplate.bind({}),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    args: {
        static: true,
        tilesPerRow: 3,
        contentCentered: false,
    },
    argTypes: {
        tilesPerRow: {
            control: {
                type: "range",
                min: 3,
                max: 5,
                step: 1,
            },
        },
        contentCentered: { type: "boolean" },
    },
};

export const Default = {};

export const WithIcon = {
    render: SmartFactoryIconTemplate.bind({}),
};

export const WithNumbers = {
    render: SmartFactoryNumbersTemplate.bind({}),
};
